import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3181b22c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title sub-title" }, "公開範囲について", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "上掲のオンライン資料について、国立国会図書館による公開範囲を選択してください。", -1))
const _hoisted_4 = { class: "table" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createTextVNode("公開範囲"),
  /*#__PURE__*/_createElementVNode("span", { class: "label required required-permission" }, "必須")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButtonList = _resolveComponent("RadioButtonList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("table", _hoisted_4, [
      _createElementVNode("tbody", null, [
        _hoisted_5,
        _createElementVNode("tr", null, [
          _hoisted_6,
          _createElementVNode("td", null, [
            _createVNode(_component_RadioButtonList, {
              modelValue: _ctx.selectedValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedValue) = $event)),
              items: _ctx.radioList,
              id: "radio-permission",
              name: "radio-permission"
            }, null, 8, ["modelValue", "items"])
          ])
        ])
      ])
    ])
  ]))
}